import type { ReconciledStatusDetail } from '@app/application/solid/services/reconciled-status-service'

import { Controller } from '@hotwired/stimulus'

import reconciledStatusService, {
  RECONCILED_STATUS_EVENT,
} from '@app/application/solid/services/reconciled-status-service'

export default class extends Controller {
  static targets = ['reconciled', 'unreconciled']

  private reconciledTarget!: HTMLElement
  private unreconciledTarget!: HTMLElement

  connect(): void {
    // The SPA may have emitted before this controller connected; the service
    // buffers the latest status so it can be replayed here.
    const buffered = reconciledStatusService().lastKnownDetail
    if (buffered) {
      this.applyStatus(buffered)
    }

    document.addEventListener(RECONCILED_STATUS_EVENT, this.updateStatus)
  }

  disconnect(): void {
    document.removeEventListener(RECONCILED_STATUS_EVENT, this.updateStatus)
  }

  private updateStatus = (event: Event): void => {
    this.applyStatus((event as CustomEvent<ReconciledStatusDetail>).detail)
  }

  private applyStatus({ reconciled }: ReconciledStatusDetail): void {
    this.reconciledTarget.classList.toggle('tw-hidden', !reconciled)
    this.unreconciledTarget.classList.toggle('tw-hidden', reconciled)
  }
}
